import ActionTypes from "../../../constants";
import {
  CityType,
  PostalCodeType,
  BusinessPartnerOptionType,
  BusinessPartnerType,
  CityPayloadType,
  BusinessPartnerPayLoadType,
  PostalCodePayloadType,
  StateProviceType,
  BankAccountNumberType,
  DuplicateBPCheckPayloadType,
  BicSwiftType,
  BankType,
  BankBranchType
} from "../types";
import businessPartner from "./reducer";
import { PaginationInfoType } from "../../BusinessPartnerLists/types";

export interface FetchLookUpActionType {
  type: typeof ActionTypes.FETCH_LOOKUP;
}

export const fetchLookUp = (): FetchLookUpActionType => ({
  type: ActionTypes.FETCH_LOOKUP
});
export interface FetchLookUpSucceededActionType {
  type: typeof ActionTypes.FETCH_LOOKUP_SUCCEEDED;
  lookup: string[];
}

export const fetchLookUpSucceeded = (
  lookup: string[]
): FetchLookUpSucceededActionType => ({
  type: ActionTypes.FETCH_LOOKUP_SUCCEEDED,
  lookup
});

export interface RetainUpdatedBusinessPartnerActionType {
  type: typeof ActionTypes.RETAIN_UPDATED_BUSINESS_PARTNER;
  businessPartnerID: number;
}

export const retainUpdatedBusinessParter = (
  businessPartnerID: number
): RetainUpdatedBusinessPartnerActionType => ({
  type: ActionTypes.RETAIN_UPDATED_BUSINESS_PARTNER,
  businessPartnerID
});
export interface RetainUpdatedBusinessPartnerSucceededActionType {
  type: typeof ActionTypes.RETAIN_UPDATED_BUSINESS_PARTNER_SUCCEEDED;
  retainedData: number;
}

export const retainUpdatedBusinessParterSucceeded = (
  retainedData: any
): RetainUpdatedBusinessPartnerSucceededActionType => ({
  type: ActionTypes.RETAIN_UPDATED_BUSINESS_PARTNER_SUCCEEDED,
  retainedData
});

export interface fetchCitiesAndPostalCodesByCountryActtionType {
  type: typeof ActionTypes.FETCH_CITIES_AND_POSTAL_CODES_BY_COUNTRY;
  countryID: number;
}

export const fetchCitiesAndPostalCodesByCountry = (
  countryID: number
): fetchCitiesAndPostalCodesByCountryActtionType => ({
  type: ActionTypes.FETCH_CITIES_AND_POSTAL_CODES_BY_COUNTRY,
  countryID
});

export interface FetchCitiesAndPostalCodesByCountrySucceededActionType {
  type: typeof ActionTypes.FETCH_CITIES_AND_POSTAL_CODES_BY_COUNTRY_SUCCEEDED;
  cities: CityType[];
  postalCodes: PostalCodeType[];
  stateProvinces: StateProviceType[];
}

export const fetchCitiesAndPostalCodesByCountrySucceeded = (
  cities: CityType[],
  postalCodes: PostalCodeType[],
  stateProvinces: StateProviceType[]
): FetchCitiesAndPostalCodesByCountrySucceededActionType => ({
  type: ActionTypes.FETCH_CITIES_AND_POSTAL_CODES_BY_COUNTRY_SUCCEEDED,
  cities,
  postalCodes,
  stateProvinces
});

export interface CheckDubplicateOfActionType {
  type: typeof ActionTypes.CHECK_DUBPLICATE_OF;
  payload: DuplicateBPCheckPayloadType;
}

export const checkDubplicateOf = (
  payload: DuplicateBPCheckPayloadType
): CheckDubplicateOfActionType => ({
  type: ActionTypes.CHECK_DUBPLICATE_OF,
  payload
});

export interface CheckDubplicateOfSucceededActionType {
  type: typeof ActionTypes.CHECK_DUBPLICATE_OF_SUCCEEDED;
  duplicateBPs: BusinessPartnerType[] | null;
  paginationInfo: PaginationInfoType;
}

export const checkDubplicateOfSucceeded = (
  duplicateBPs: BusinessPartnerType[] | null,
  paginationInfo: PaginationInfoType
): CheckDubplicateOfSucceededActionType => ({
  type: ActionTypes.CHECK_DUBPLICATE_OF_SUCCEEDED,
  duplicateBPs,
  paginationInfo
});

export interface ResetDuplicateBPsActionType {
  type: typeof ActionTypes.RESET_DUPLICATE_BPS;
}

export const resetDuplicateBPs = (): ResetDuplicateBPsActionType => ({
  type: ActionTypes.RESET_DUPLICATE_BPS
});

export interface DeleteDuplicateBPActionType {
  type: typeof ActionTypes.DELETE_DUPLICATE_BP;
  businessPartnerID: number;
}

export const deleteDuplicateBP = (
  businessPartnerID: number
): DeleteDuplicateBPActionType => ({
  type: ActionTypes.DELETE_DUPLICATE_BP,
  businessPartnerID
});

export interface DeleteDuplicateBPSucceededActionType {
  type: typeof ActionTypes.DELETE_DUPLICATE_BP_SUCCEEDED;
  deletedBPID: number;
}

export const deleteDuplicateBPSucceeded = (
  deletedBPID: number
): DeleteDuplicateBPSucceededActionType => ({
  type: ActionTypes.DELETE_DUPLICATE_BP_SUCCEEDED,
  deletedBPID
});

export interface ResetDuplicateBPDeletedFlagActionType {
  type: typeof ActionTypes.RESET_DUPLICATE_BP_DELETED_FLAG;
}

export const resetDuplicateBPDeletedFlag = (): ResetDuplicateBPDeletedFlagActionType => ({
  type: ActionTypes.RESET_DUPLICATE_BP_DELETED_FLAG
});

export interface CreateCityActionType {
  type: typeof ActionTypes.CREATE_CITY;
  payload: CityPayloadType;
  cityOf: string;
}

export const createCity = (payload: CityPayloadType, cityOf: string): CreateCityActionType => ({
  type: ActionTypes.CREATE_CITY,
  payload,
  cityOf
});

export interface CreateCitySucceededActionType {
  type: typeof ActionTypes.CREATE_CITY_SUCCEEDED;
  city: CityType;
}

export const createCitySucceeded = (
  city: CityType
): CreateCitySucceededActionType => ({
  type: ActionTypes.CREATE_CITY_SUCCEEDED,
  city
});
export const createPoBoxCitySucceeded = (
  city: CityType
): CreateCitySucceededActionType => ({
  type: ActionTypes.CREATE_POBOX_CITY_SUCCEEDED,
  city
});

export interface UpdateCityActionType {
  type: typeof ActionTypes.UPDATE_CITY;
  cityID: number;
  payload: CityPayloadType;
  cityOf: string;
}

export const updateCity = (
  cityID: number,
  payload: CityPayloadType,
  cityOf: string

): UpdateCityActionType => ({
  type: ActionTypes.UPDATE_CITY,
  cityID,
  payload,
  cityOf
});

export interface UpdateCitySucceededActionType {
  type: typeof ActionTypes.UPDATE_CITY_SUCCEEDED;
  city: CityType;
}

export const updateCitySucceeded = (
  city: CityType
): CreateCitySucceededActionType => ({
  type: ActionTypes.UPDATE_CITY_SUCCEEDED,
  city
});
export const updatePoBoxCitySucceeded = (
  city: CityType
): CreateCitySucceededActionType => ({
  type: ActionTypes.UPDATE_POBOX_CITY_SUCCEEDED,
  city
});

export interface ResetCityUpdatedFlagActionType {
  type: typeof ActionTypes.RESET_CITY_UPDATED_FLAG;
}
export const resetCityUpdatedFlag = (): ResetCityUpdatedFlagActionType => ({
  type: ActionTypes.RESET_CITY_UPDATED_FLAG
});

export interface CreateBusinessPartnerActionType {
  type: typeof ActionTypes.CREATE_BUSINESS_PARTNER;
  payload: BusinessPartnerPayLoadType;
}

export const createBusinessPartner = (
  payload: BusinessPartnerPayLoadType
): CreateBusinessPartnerActionType => ({
  type: ActionTypes.CREATE_BUSINESS_PARTNER,
  payload
});
export interface CreateBusinessPartnerSucceededActionType {
  type: typeof ActionTypes.CREATE_BUSINESS_PARTNER_SUCCEEDED;
}

export const createBusinessPartnerSucceeded = (): CreateBusinessPartnerSucceededActionType => ({
  type: ActionTypes.CREATE_BUSINESS_PARTNER_SUCCEEDED
});

export interface UpdateBusinessPartnerActionType {
  type: typeof ActionTypes.CREATE_BUSINESS_PARTNER;
  payload: BusinessPartnerPayLoadType;
}

export const updateBusinessPartner = (
  payload: BusinessPartnerPayLoadType
): UpdateBusinessPartnerActionType => ({
  type: ActionTypes.UPDATE_BUSINESS_PARTNER,
  payload
});
export interface UpdateBusinessPartnerSucceededActionType {
  type: typeof ActionTypes.CREATE_BUSINESS_PARTNER_SUCCEEDED;
  status: number;
}

export const updateBusinessPartnerSucceeded = (
  status: number
): UpdateBusinessPartnerSucceededActionType => ({
  type: ActionTypes.UPDATE_BUSINESS_PARTNER_SUCCEEDED,
  status
});

export interface ResetCityCreatedFlagActionType {
  type: typeof ActionTypes.RESET_CITY_CREATED_FLAG;
}
export const resetCityCreatedFlag = (): ResetCityCreatedFlagActionType => ({
  type: ActionTypes.RESET_CITY_CREATED_FLAG
});

export interface ResetBPCreatedFlagActionType {
  type: typeof ActionTypes.RESET_BP_CRREATED_FLAG;
}

export const resetBPCreatedFlag = (): ResetBPCreatedFlagActionType => ({
  type: ActionTypes.RESET_BP_CRREATED_FLAG
});

export interface ResetBPUpdatedFlagActionType {
  type: typeof ActionTypes.RESET_BP_UPDATED_FLAG;
}

export const resetBPUpdatedFlag = (): ResetBPUpdatedFlagActionType => ({
  type: ActionTypes.RESET_BP_UPDATED_FLAG
});

export interface SetSelectedBPActionType {
  type: typeof ActionTypes.SET_SELECTED_BP;
  selectedBP: BusinessPartnerType;
}

export const setSelectedBP = (
  selectedBP: BusinessPartnerType
): SetSelectedBPActionType => ({
  type: ActionTypes.SET_SELECTED_BP,
  selectedBP
});

export interface CreatePostalCodeActionType {
  type: typeof ActionTypes.CREATE_POSTAL_CODE;
  payload: PostalCodePayloadType;
  zipCodeOf: string
}

export const createPostalCode = (
  payload: PostalCodePayloadType,
  zipCodeOf: string
): CreatePostalCodeActionType => ({
  type: ActionTypes.CREATE_POSTAL_CODE,
  payload,
  zipCodeOf
});

export interface CreatePostalCodeSucceededActionType {
  type: typeof ActionTypes.CREATE_POSTAL_CODE_SUCCEEDED;
  postalCode: PostalCodeType;
}

export const createPostalCodeSucceeded = (
  postalCode: PostalCodeType
): CreatePostalCodeSucceededActionType => ({
  type: ActionTypes.CREATE_POSTAL_CODE_SUCCEEDED,
  postalCode
});

export const createPoBoxPostalCodeSucceeded = (
  postalCode: PostalCodeType
): CreatePostalCodeSucceededActionType => ({
  type: ActionTypes.CREATE_POBOX_POSTAL_CODE_SUCCEEDED,
  postalCode
});

export interface ResetPostalCodeCreatedFlagActionType {
  type: typeof ActionTypes.RESET_POSTAL_CODE_CREATED_FLAG;
}
export const resetPostalCodeCreatedFlag = (): ResetPostalCodeCreatedFlagActionType => ({
  type: ActionTypes.RESET_POSTAL_CODE_CREATED_FLAG
});

export interface UpdatePostalCodeActionType {
  type: typeof ActionTypes.UPDATE_POSTAL_CODE;
  postalCodeID: number;
  payload: PostalCodePayloadType;
  zipCodeOf: string
}

export const updatePostalCode = (
  postalCodeID: number,
  payload: PostalCodePayloadType,
  zipCodeOf
): UpdatePostalCodeActionType => ({
  type: ActionTypes.UPDATE_POSTAL_CODE,
  postalCodeID,
  payload,
  zipCodeOf
});

export interface UpdatePostalCodeSucceededActionType {
  type: typeof ActionTypes.UPDATE_POSTAL_CODE_SUCCEEDED;
  postalCode: PostalCodeType;
}

export const updatePostalCodeSucceeded = (
  postalCode: PostalCodeType
): UpdatePostalCodeSucceededActionType => ({
  type: ActionTypes.UPDATE_POSTAL_CODE_SUCCEEDED,
  postalCode
});
export const updatePoBoxPostalCodeSucceeded = (
  postalCode: PostalCodeType
): UpdatePostalCodeSucceededActionType => ({
  type: ActionTypes.UPDATE_POBOX_POSTAL_CODE_SUCCEEDED,
  postalCode
});

export interface ResetPostalCodeUpdatedFlagActionType {
  type: typeof ActionTypes.RESET_POSTAL_CODE_UPDATED_FLAG;
}
export const resetPostalCodeUpdatedFlag = (): ResetPostalCodeUpdatedFlagActionType => ({
  type: ActionTypes.RESET_POSTAL_CODE_UPDATED_FLAG
});

export interface FetchBankNumbersAciontType {
  type: typeof ActionTypes.FETCH_BANK_NUMBERS;
  bankID: number;
}

export const fetchBankNumbers = (
  bankID: number
): FetchBankNumbersAciontType => ({
  type: ActionTypes.FETCH_BANK_NUMBERS,
  bankID
});

export interface FetchBankNumbersSucceededActionType {
  type: typeof ActionTypes.FETCH_BANK_NUMBERS_SUCCEEDED;
  bankNumbers: BankAccountNumberType[];
}

export const fetchBankNumbersSucceeded = (
  bankNumbers: BankAccountNumberType[]
): FetchBankNumbersSucceededActionType => ({
  type: ActionTypes.FETCH_BANK_NUMBERS_SUCCEEDED,
  bankNumbers
});

export interface ResetSelectedBPActionType {
  type: typeof ActionTypes.RESET_SELECTED_BP;
}

export const resetSelectedBP = (): ResetSelectedBPActionType => ({
  type: ActionTypes.RESET_SELECTED_BP
});

export interface DeleteBusinessPartnerActionType {
  type: typeof ActionTypes.DELETE_BUSINESS_PARTNER;
  businessPartnerID: number;
}

export const deleteBusinessPartner = (
  businessPartnerID: number
): DeleteBusinessPartnerActionType => ({
  type: ActionTypes.DELETE_BUSINESS_PARTNER,
  businessPartnerID
});

export interface DeleteBusinessPartnerSucceededActionType {
  type: typeof ActionTypes.DELETE_BUSINESS_PARTNER_SUCCEEDED;
}

export const deleteBusinessPartnerSucceeded = (): DeleteBusinessPartnerSucceededActionType => ({
  type: ActionTypes.DELETE_BUSINESS_PARTNER_SUCCEEDED
});

export interface ResetDeleteBPSucceededActionType {
  type: typeof ActionTypes.RESET_DELETE_BP_SUCCEEDED;
}

export const resetDeleteBPSucceeded = (): ResetDeleteBPSucceededActionType => ({
  type: ActionTypes.RESET_DELETE_BP_SUCCEEDED
});

export interface FlushCountryDependentLookupDataActionType {
  type: typeof ActionTypes.FLUSH_COUNTRY_DEPENDENT_LOOKUP_DATA;
}

export const flushCountryDependentLookupData = (): FlushCountryDependentLookupDataActionType => ({
  type: ActionTypes.FLUSH_COUNTRY_DEPENDENT_LOOKUP_DATA
});

export interface FetchBicSwiftsActionType {
  type: typeof ActionTypes.FETCH_BIC_SWIFTS;
  bankCountryCode: string
}

export const fetchBicSwifts = (bankCountryCode: string): FetchBicSwiftsActionType => ({
  type: ActionTypes.FETCH_BIC_SWIFTS,
  bankCountryCode,
});

export interface FetchBicSwiftsSucceededActionType {
  type: typeof ActionTypes.FETCH_BIC_SWIFTS_SUCCEEDED;
  bicSwifts: BicSwiftType[];
}

export const fetchBicSwiftsSucceeded = (
  bicSwifts: BicSwiftType[]
): FetchBicSwiftsSucceededActionType => ({
  type: ActionTypes.FETCH_BIC_SWIFTS_SUCCEEDED,
  bicSwifts
});

export interface ResetBicSwiftsActionType {
  type: typeof ActionTypes.RESET_BIC_SWIFTS;
}

export const resetBicSwifts = (): ResetBicSwiftsActionType => ({
  type: ActionTypes.RESET_BIC_SWIFTS
});
export interface fetchBankBranchActionType {
  type: typeof ActionTypes.FETCH_BANK_BRANCH;
  bicSwiftCode: string;
}

export const fetchBankBranch = (bicSwiftCode: string): fetchBankBranchActionType => ({
  type: ActionTypes.FETCH_BANK_BRANCH,
  bicSwiftCode
});


export interface fetchBankBranchSucceededActionType {
  type: typeof ActionTypes.FETCH_BANK_BRANCH_SUCCEEDED;
  bankBranch: BankBranchType
}

export const fetchBankBranchSucceeded = (bankBranch: BankBranchType): fetchBankBranchSucceededActionType => ({
  type: ActionTypes.FETCH_BANK_BRANCH_SUCCEEDED,
  bankBranch,
});


export interface ResetBankBranchActionType {
  type: typeof ActionTypes.RESET_BANK_BRANCH;
}


export const resetBankBranch = (): ResetBankBranchActionType => ({
  type: ActionTypes.RESET_BANK_BRANCH,
});